export const LINK_FIELD_NAME = "linkData";
